<script lang="ts">
	//Svelte helper
	import { createEventDispatcher } from 'svelte';
	//Constatns
	import { week_days } from '../../constants';
	//Services
	import { format } from '../../services/i18n';
	//Design system components
	import { Checkbox } from '@Shelly/shelly-design-system';
	// Helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { startsWeekOnSun } from 'src/helpers/date_helper';

	let className = '';
	export { className as class };
	export let days = [0, 2, 4, 5];

	const dispatch = createEventDispatcher();

	const update_week_group = (ind) => {
		if (days.includes(ind)) {
			days = [...days.filter((el) => el !== ind)];
		} else {
			days.push(ind);
		}
		dispatch('change', days);
	};

	const weekDays = week_days.slice();
	if (startsWeekOnSun()) {
		weekDays.unshift(weekDays.pop());
	}
</script>

<div
	class={classMap({
		days_wrapper: true,
		[className]: true,
	})}
>
	{#each weekDays as day, _i}
		<Checkbox
			on:click={() => update_week_group(day.from_zero_ind)}
			isVertical={true}
			checked={days.includes(day.from_zero_ind)}
			id="checkbox-ylceadx">{$format(day.i18n).slice(0, 1)}</Checkbox
		>
	{/each}
</div>

<style>
	.days_wrapper {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}
</style>
